export const isDevelopment =
  process.env.NEXT_PUBLIC_VERCEL_ENV === "development";

export const isProduction = process.env.NEXT_PUBLIC_VERCEL_ENV === "production";

export const isPreview =
  process.env.VERCEL_ENV === "preview" ||
  process.env.NEXT_PUBLIC_VERCEL_ENV === "preview";

const hostname = globalThis.window?.location?.hostname;

const isStagingFromHostname = hostname?.endsWith("zapier-staging.com") === true;

// Server-side fallback
const isStagingFromGitReference =
  process.env.VERCEL_GIT_COMMIT_REF === "staging";

export const isStaging = isStagingFromHostname || isStagingFromGitReference;

export const referer = isProduction
  ? "https://zapier.com"
  : "https://zapier-staging.com";

export const baseUrl =
  process.env.NEXT_PUBLIC_ZAPIER_ORIGIN || process.env.BASE_URL;

export const serviceBaseUrl = `${baseUrl}/api/v1/projects/`;
